import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { apiGet, apiPost } from "api/callApi";
import { showAlert } from "utils/helper";

function AddEditCompany(props) {
  const {
    isEditing,
    setOpenModalView,
    setIsEditing,
    openModalView,
    fieldData,
    setFieldData = () => {},
    reloadData,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(fieldData || {});

  const handleChangeCompany = (property, value) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  useEffect(() => {
    if (isEditing) {
      setData(fieldData);
    }
  }, [isEditing, fieldData]);

  // Handle form submission for Add or Edit
  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (isEditing) {
        const payload = {
          companyId: fieldData.id,
          companyName: data.companyName,
        };
        const response = await apiPost(
          `/v1/editcompany/${payload.companyId}`,
          payload,
          false
        );
        showAlert({
          title: "Success",
          text: response.message || "Company updated successfully",
          icon: "success",
        });

        await reloadData();
        setOpenModalView(false);
        setIsEditing(false);
        setData("");
        setFieldData(null);
      } else {
        if (!data.companyName || data.companyName.trim() === "") {
          showAlert({
            title: "Error",
            text: "Company name is required",
            icon: "error",
          });
          return;
        }
        const response = await apiPost(`/v1/addcompany`, data);
        showAlert({
          title: "Success",
          text: response.message,
          icon: "success",
        });
        await reloadData(response.data);
        setOpenModalView(false);
        setData("");
        setFieldData(null);
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
        button: "Try Again",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelCompanyModal = () => {
    setOpenModalView(false);
    setData({});
    if (typeof setFieldData === "function") {
      setFieldData(null);
    }
  };

  const handleCancelCompanyModalisEditing = () => {
    setOpenModalView(false);
    setIsEditing(false);
    setData({});
    if (typeof setFieldData === "function") {
      setFieldData(null);
    }
  };

  const AddCompanyModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "30px" }}>
          <Label label={"Company Name"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <InputField
                name="companyName"
                value={data.companyName}
                onChange={handleChangeCompany}
                required
                style={{ width: "100%" }}
                // capitalize
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          {isEditing ? (
            <Button
              caption="Cancel"
              onClick={handleCancelCompanyModalisEditing}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "90px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
          ) : (
            <Button
              caption="Cancel"
              onClick={handleCancelCompanyModal}
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "90px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
          )}
          <Button
            caption={isEditing ? "Save" : "Add"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView &&
        (isEditing ? (
          <BulkActionView
            title={"Edit Company"}
            openModal={openModalView}
            renderBodyConditionally={AddCompanyModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setIsEditing(false);
              setData("");
              if (typeof setFieldData === "function") {
                setFieldData(null);
              }
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ) : (
          <BulkActionView
            title={"New Company"}
            openModal={openModalView}
            renderBodyConditionally={AddCompanyModalData}
            handleCloseModal={() => {
              setOpenModalView(false);
              setData("");
              if (typeof setFieldData === "function") {
                setFieldData(null);
              }
            }}
            sx={{
              minWidth: "550px",
            }}
          />
        ))}
    </>
  );
}

export default AddEditCompany;

const DownloadZipButton = ({ projectId, type }) => {
  const [isPreparing, setIsPreparing] = useState(false);
  const [error, setError] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [intervalId]);

  const handleDownloadClick = async () => {
    setIsPreparing(true);
    setError(null);
    setElapsedTime(0);

    const timerInterval = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
    setIntervalId(timerInterval);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/v1/getprojectzip?projectId=2&type=0`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/zip",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to download file. Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "projectData.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      clearInterval(timerInterval);
      setIsPreparing(false);
    } catch (error) {
      clearInterval(timerInterval);
      setIsPreparing(false);
      setError("There was an error preparing your download. Please try again.");
      console.error(error);
    }
  };

  return (
    <div>
      <button
        onClick={handleDownloadClick}
        disabled={isPreparing}
        style={{
          background: "orange",
          border: "none",
          color: "#fff",
          fontWeight: "bold",
          padding: "12px 24px",
          borderRadius: "8px",
          cursor: isPreparing ? "not-allowed" : "pointer",
          textTransform: "uppercase",
          fontSize: "16px",
          transition: "all 0.3s ease",
        }}
      >
        export
      </button>
      {isPreparing && (
        <p>
          Preparing your download...(This may take some time) {elapsedTime}s
        </p>
      )}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};
